// AddressStep.js
import { Row, Col, Form, Input, Button, Space } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined, HomeOutlined, EditFilled, CloseOutlined } from '@ant-design/icons';

import { SearchSelect } from './../../../../../../component/Button';

const AddressStep = ({ form, goNext, goPrev, cpValidated, setCpValidated, catLocalidades, loading, getLocalidadesByCP, siteType = "registro_egresados" }) => {

    const onChangeCP = async (e) => {
        const cp = e.target.value;

        const isValid = /^\d{5}$/.test(cp);
        setCpValidated(isValid);

        // Limpia los otros campos solo si el CP cambia
        form.setFieldsValue({
            municipio: null,
            estado: null,
            id_colonia: null,
        });
    };
    const onChangeColonia = async (colonia) => {
        const info = catLocalidades.find(item => item.id === colonia);
        if (!info) return;
        form.setFieldsValue({ municipio: info.municipio, estado: info.estado });
    };

    const buscarLocalidad = async () => {
        const codigoPostal = form.getFieldValue("codigo_postal");
        await getLocalidadesByCP(codigoPostal);
    };

    return (
        <Row align="middle" justify="center">
            <Col xs={24} sm={20}>
                <Form.Item label="Calle y Número" name="calle_y_numero" rules={[
                    { required: true, message: 'Ingresa tu calle' },
                    { whitespace: true },
                    {min: 3, max: 100, message: 'La calle debe tener entre 3 y 100 caracteres'},
                ]}>
                    <Input prefix={<HomeOutlined />} placeholder="Calle 123" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item label="Código Postal" name="codigo_postal" rules={[
                    { required: true, message: 'Ingresa tu código postal' },
                    { pattern: /^\d{5}$/, message: 'Debe tener 5 dígitos' }
                ]}>
                    <Input.Search
                        placeholder="12345"
                        loading={loading}
                        onChange={onChangeCP}
                        onSearch={buscarLocalidad}
                        enterButton={
                            <Button
                                type="primary"
                                disabled={!cpValidated}
                                loading={loading}
                            >
                                Buscar
                            </Button>
                        }
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item label="Colonia" name="id_colonia" rules={[
                    { required: true, message: 'Ingresa tu colonia' }
                ]}>
                    <SearchSelect placeholder="Selecciona tu colonia" disabled={!cpValidated || catLocalidades?.length === 0} dataset={catLocalidades} onChange={onChangeColonia} />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item label="Municipio" name="municipio" tooltip="Información obtenida del Código Postal">
                    <Input prefix={<HomeOutlined />} disabled placeholder="Municipio" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item label="Estado" name="estado" tooltip="Información obtenida del Código Postal">
                    <Input prefix={<HomeOutlined />} disabled placeholder="Estado" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20} align="center">
                <Space justify="space-evenly">
                    <Button icon={siteType === "registro_egresados" ? <ArrowLeftOutlined /> : <CloseOutlined />} onClick={goPrev} loading={loading}>{siteType === "registro_egresados" ? "Atrás" : "Cancelar"}</Button>
                    <Button icon={siteType === "registro_egresados" ? <ArrowRightOutlined /> : <EditFilled />} type="primary" onClick={goNext} loading={loading}>{siteType === "registro_egresados" ? "Siguiente" : "Guardar"}</Button>
                </Space>
            </Col>
        </Row>
    );
};
export default AddressStep;